import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../Components/Atoms/CustomButton";
import { useFormik } from "formik";
import CustomSelect from "../../../Components/Atoms/CustomSelect";
import CustomInput from "../../../Components/Atoms/CustomInput";
import * as Yup from "yup";
import {
  postMasterRequest,
  putMasterRequest,
} from "../../../Redux/Master/MasterActions";
import { useEffect } from "react";

const CreateMaster = ({ handleClose, data, type }) => {
  const dispatch = useDispatch();
  const action = data ? "edit" : "new";
  const { postMasterLoading } = useSelector((state) => state.masterReducer);

  const formik = useFormik({
    initialValues: {
      name: "",
      status: "ACTIVE",
    },
    onSubmit: (values) => {
      if (postMasterLoading) return;
      if (action === "new") {
        dispatch(
          postMasterRequest({
            ...values,
            type,
          })
        );
      } else {
        dispatch(
          putMasterRequest({
            ...values,
            id: data?._id,
            type,
          })
        );
      }
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required("Required"),
      status: Yup.string().required("Required"),
    }),
  });

  useEffect(() => {
    if (action === "edit") {
      Object.keys(formik.values).forEach((e) => {
        formik.setFieldValue(e, data[e]);
      });
    } else {
      formik.resetForm();
    }
  }, [data]);

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <div className="row">
          <div className="col-md-6">
            <div className="d-flex">
              <p className="mb-1">Name</p>
              <p className="erroStar">*</p>
            </div>
            <CustomInput
              type="text"
              name="name"
              placeholder="Enter name"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.name}
              formik={formik}
            />
          </div>
          <div className="col-md-6">
            <div className="d-flex">
              <p className="mb-1">Status</p>
              <p className="erroStar">*</p>
            </div>
            <CustomSelect
              type="text"
              name="status"
              placeholder="SELECT AN OPTION"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.status}
              formik={formik}
              data={[
                { name: "ACTIVE", value: "ACTIVE" },
                { name: "INACTIVE", value: "INACTIVE" },
              ]}
            />
          </div>
        </div>
        <div className="btnActnBar">
          <CustomButton
            btnType="secondary"
            onClick={handleClose}
            label={"Cancel"}
            action={"CANCEL"}
          />
          <CustomButton
            label={postMasterLoading ? "Loading..." : "Save"}
            type="submit"
            action={"SAVE"}
          />
        </div>
      </form>
    </>
  );
};

export default CreateMaster;
